

const storeComplaintLabel = (complaintLabel) => {
    let complaintLabelArray = complaintLabel    
    console.log("storedArray is",complaintLabelArray)
    localStorage.setItem("complaintLabel",JSON.stringify(complaintLabelArray));
}

const getComplaintLabel = () => {
    return JSON.parse(localStorage.getItem("complaintLabel"))
}

const storeIncidentLabel = (incidentLabel) => {
    let incidentLabelArray = incidentLabel    
    console.log("incidentLabelArray is",incidentLabelArray)
    localStorage.setItem("incidentLabel",JSON.stringify(incidentLabelArray));
}

const getIncidentLabel = () => {
    return JSON.parse(localStorage.getItem("incidentLabel"))
}

const storeComment = (comment) => {
   return localStorage.setItem("storedComment",JSON.stringify(comment));
}

const storeLanguagePreference = (language) => {
    localStorage.setItem("storeLanguagePreference",language);
}

const getLanguagePreference = () => {
    return localStorage.getItem("storeLanguagePreference")
}


const storeLoginSelection = () => {
    return localStorage.setItem("storeLoginSelection",true);
}
const getStoredLoginSelection = () => {
    return localStorage.getItem("storeLoginSelection");
}

const getComment = () => {
    console.log("localStorage.getItem(storedComment)",JSON.parse(localStorage.getItem("storedComment")))
    return JSON.parse(localStorage.getItem("storedComment"))
}

const storeImages = (images) => {
    return localStorage.setItem("storedImages",JSON.stringify(images));
 }

 const getImages = () => {
    console.log("localStorage.getItem(getImages)",JSON.parse(localStorage.getItem("storedImages")))
    return localStorage.getItem("storedImages")
}

const clearLoginSelection = () => {
    localStorage.removeItem("storeLoginSelection")

}

const storeIsTabopen = () => {
    return localStorage.setItem("isTabOpen",true);
} 

const getIsTabOpen = () => {
    return localStorage.getItem("isTabOpen");
}

const setWindowOpen = () =>{
    return localStorage.setItem("trustbuilderwindowopen",true);
}

const getWindowOpen = () => {
    return JSON.parse(localStorage.getItem("trustbuilderwindowopen"));
}

const clearWindowOpen = () => {
    return localStorage.setItem("trustbuilderwindowopen",false);
}

const clearSelectionStorage = () => {
    console.log("clearSelectionStorage called");
    localStorage.removeItem("storedImages")
    localStorage.removeItem("storedComment")
    localStorage.removeItem("incidentLabel")
    localStorage.removeItem("complaintLabel") 
    localStorage.removeItem("storeLoginSelection")
    localStorage.removeItem("storeAPIImages")
}

const clearIncidentStorage = () => {
    localStorage.removeItem("incidentLabel")
}

const clearComplaintStorage = () => {
    localStorage.removeItem("complaintLabel")
}

const storeNMBSLoginSelection = () => {
    localStorage.setItem("NMBSLoginSelection",true);
}

const getNMBSLoginSelection = () => {
    return JSON.parse(localStorage.getItem("NMBSLoginSelection"));

}

const clearNMBSLoginSelection = () =>{
    localStorage.removeItem("NMBSLoginSelection");
}

const storeNMBSLoadingSelection = () => {
    localStorage.setItem("NMBSLoadingSelection",true);
}

const getNMBSLoadingSelection = () => {
    return JSON.parse(localStorage.getItem("NMBSLoadingSelection"));

}

const clearNMBSLoadingSelection = () =>{
    localStorage.removeItem("NMBSLoadingSelection");
}

const openAuthenticationTab = async () => {
    storeLoginSelection();
    storeNMBSLoginSelection();
    storeNMBSLoadingSelection();
    setWindowOpen();
    localStorage.setItem("isNMBSLoginInitiated",true)
    localStorage.setItem("isNMBSEmployeeLoginNeeded",true)
	window.location.reload();
}

const closeAuthenticationTab = async () => {
    
    clearWindowOpen();
}

const storeAPIImages = (images) => {
    return localStorage.setItem("storeAPIImages",JSON.stringify(images));
 }
  
 const getStoredAPIImages = () => {
    console.log("localStorage.getItem(getImages)",JSON.parse(localStorage.getItem("storedImages")))
    return localStorage.getItem("storeAPIImages")
}

export {clearComplaintStorage,clearIncidentStorage,storeNMBSLoadingSelection,getNMBSLoadingSelection,clearNMBSLoadingSelection,storeAPIImages,getStoredAPIImages,setWindowOpen,getWindowOpen,clearWindowOpen, getLanguagePreference,storeLanguagePreference,storeNMBSLoginSelection,getNMBSLoginSelection,clearNMBSLoginSelection,openAuthenticationTab,closeAuthenticationTab,storeIsTabopen,getIsTabOpen,clearLoginSelection,storeLoginSelection,getStoredLoginSelection,storeComplaintLabel,getComplaintLabel,storeComment,getComment,storeIncidentLabel,getIncidentLabel,storeImages,getImages,clearSelectionStorage}